import pino from 'pino';

const logger = pino({
  level: 'info',
  prettyPrint: { colorize: true }
});

export default logger;
